import utils from '@/utils';
import { clone, buildApiQuery } from '@/utils/dataUtil';
import { PPA_REF_API } from '@/api';
import { getMomentDateString } from '@/utils/dateUtil';

const state = {
  tableKey: -999,
  currentTableRow: null,
  tableData: [],
  contractList: [],
  // valueTypeList: [],
  nullTableRow: {
    id: -999,
    ppaId: null,
    ppaName: null,
    customer: null,
    tsType: null,
    tsClass: null,
    tsIncrement: null,
    aref: null,
    effectiveDate: null,
    terminationDate: null,
    updatedBy: null,
    updatedDate: null,
    createdBy: null,
    createdDate: null,
  },
};

const getters = {
  getContractList: (state) => state.contractList.map(({ id, name }) => ({ value: id, label: name })),
  // getValueTypeList: (state) => state.valueTypeList.map(({ valueType }) => valueType),
};

const actions = {
  initialize({ dispatch }) {
    dispatch('fetchContractList');
    // dispatch('fetchValueTypes');
  },
  async fetchReservation({ commit }, parameters = {}) {
    const params = {
      contracts: parameters.ppasSelected,
    };
    try {
      const { data: { data } } = await PPA_REF_API.post('/reservation/get', params);
      if (Array.isArray(data)) {
        data.forEach((x) => {
          x.effectiveDate = getMomentDateString(x.effectiveDate);
          x.terminationDate = x.terminationDate === null ? null : getMomentDateString(x.terminationDate);
        });
        commit('setTableData', data);
      }
    } catch (err) {
      console.error(err);
      this.$notify('Failed to load Reservation Data', 'error');
    }
  },
  async fetchContractList({ commit }) {
    try {
      const { data: { data } } = await PPA_REF_API.get('/ppa');
      commit('loadContractList', data);
    } catch (err) {
      this.$notify('Failed to fetch Contract list', 'error');
      console.error(err);
    }
  },
  /*
  async fetchValueTypes({ commit }) {
    try {
      const { data: { data } } = await PPA_REF_API.get('reservation/types');
      commit('loadValueTypesList', data);
    } catch (err) {
      this.$notify('Failed to fetch value types', 'error');
      console.error(err);
    }
  }, */
  async postRecord({ state }, reservation) {
    try {
      const result = await PPA_REF_API.post('/reservation', reservation);
      state.tableData.push(result.data);
      this.$notify('Data Added', 'success');
    } catch (err) {
      console.error(err);
      if (err.response.data === 'Reference data already exists') {
        this.$notify('Failed to Add Data. Data already exists', 'error');
      } else {
        this.$notify('Failed to Add Data', 'error');
      }
    }
  },
  async updateRecord({ dispatch, commit, state }, reservation) {
    try {
      const result = await PPA_REF_API.put(`/reservation/${reservation.id}`, reservation);
      commit('updateRecord', result.data);
      this.$notify('Data Updated', 'success');
    } catch (err) {
      console.error(err);
      this.$notify('Failed to Update Data', 'error');
    }
  },
  async deleteTableRow({ dispatch, commit, state }) {
    try {
      await PPA_REF_API.delete(`/reservation/${state.currentTableRow.id}`);
      commit('deleteTableRow');
      commit('currentTableRowChange', clone(state.nullTableRow));
      this.$notify('Data Removed', 'success');
    } catch (err) {
      console.error(err);
      this.$notify('Failed to Remove Data', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  updateRecord(state, record) {
    const rowIndex = state.tableData.findIndex(({ id }) => id === record.id);
    state.tableData.splice(rowIndex, 1, record);
  },
  currentTableRowChange(state, currentRow) {
    state.currentTableRow = currentRow;
  },
  reset(state) {
    state.tableData = [];
  },
  loadContractList(state, contracts) {
    state.contractList = contracts;
  },
  /*
  loadValueTypesList(state, valueTypes) {
    state.valueTypeList = valueTypes;
  }, */
  createTableRow(state) {
    const record = clone(state.nullTableRow);
    record.id = state.tableKey++;
    record.versionId = 1;
    record.createdBy = this.getters['auth/getProfile'].userName;
    record.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = record;
  },
  copyTableRow(state) {
    const record = clone(state.currentTableRow);
    record.id = state.tableKey++;
    record.versionId = 1;
    record.createdBy = this.getters['auth/getProfile'].userName;
    record.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = record;
  },
  deleteTableRow(state) {
    state.tableData = state.tableData.filter((record) => record.id !== state.currentTableRow.id);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};